class TitleService {
  blinkWhile(text, callback) {
    let originalTitle = document.title;
    let frame = 0;
    const frames = [
      '--<--<-',
      '-<--<--',
      '<--<--<',
    ];

    function f() {
      if (!callback()) {
        clearInterval(timerId);
        document.title = originalTitle;

        return;
      }

      frame = frame > frames.length - 2 ? 0 : frame + 1;
      document.title = document.hasFocus() ? originalTitle : `${text} ${frames[frame]}`;
    }

    let timerId = setInterval(f, 200);
  };
}

export default new TitleService();
